import faker from 'faker';

export default Array(10)
  .fill(0)
  .map((_, index) => ({
    id: index,
    tipo: faker.lorem.words(1),
    numero: faker.random.number({ min: 100, max: 500 }),
    numeroAditivoVigente: faker.random.number({ min: 1000, max: 5000 }),
    periodoInicial: faker.date.past(10).toLocaleString(),
    periodoFinal: faker.date.future(10).toLocaleString(),
    saldoFinalMedicao: faker.finance.amount(),
  }));
